import { Link } from '@tanstack/react-router'
import { ArrowUpRight, Home } from 'lucide-react'

export interface EvaluationDashboardLinkProps {
  homePath: string
}

export function EvaluationDashboardLink({ homePath }: EvaluationDashboardLinkProps) {
  return (
    <Link
      to={homePath}
      className="mt-4 flex items-center gap-3 rounded-xl border border-[#f97316]/20 bg-gradient-to-r from-[#f97316]/[0.06] to-transparent px-5 py-3 transition-colors hover:bg-[#f97316]/[0.07]"
    >
      <Home className="size-4 text-[#f97316]" />
      <span className="flex-1 text-sm text-foreground">
        This pitch updated your SeedForge review
      </span>
      <ArrowUpRight className="size-4 text-[#f97316]" />
    </Link>
  )
}
